/** Wire contract for explicitly confirming that a project has no subcontractors. */
import { z } from "zod";
import { entityIdSchema } from "../common";

/** The decision is inferred by the server; clients cannot choose a readiness key. */
export const ProjectNoSubcontractorsConfirmationRequestSchema = z.object({}).strict();
export type ProjectNoSubcontractorsConfirmationRequest = z.infer<
  typeof ProjectNoSubcontractorsConfirmationRequestSchema
>;

export const ProjectNoSubcontractorsConfirmationResponseSchema = z
  .object({
    projectId: entityIdSchema,
    confirmed: z.literal(true),
  });
/** Server egress stays exact; installed clients tolerate additive fields. */
export const ProjectNoSubcontractorsConfirmationResponseStrict =
  ProjectNoSubcontractorsConfirmationResponseSchema.strict();
export type ProjectNoSubcontractorsConfirmationResponse = z.infer<
  typeof ProjectNoSubcontractorsConfirmationResponseSchema
>;

/** The server records a workforce confirmation only after checking the locked project roster. */
export const ProjectNoWorkersConfirmationRequestSchema = z.object({}).strict();
export type ProjectNoWorkersConfirmationRequest = z.infer<
  typeof ProjectNoWorkersConfirmationRequestSchema
>;

export const ProjectNoWorkersConfirmationResponseSchema = z
  .object({
    projectId: entityIdSchema,
    confirmed: z.literal(true),
  });
/** Server egress stays exact; installed clients tolerate additive fields. */
export const ProjectNoWorkersConfirmationResponseStrict =
  ProjectNoWorkersConfirmationResponseSchema.strict();
export type ProjectNoWorkersConfirmationResponse = z.infer<
  typeof ProjectNoWorkersConfirmationResponseSchema
>;
